import {
  formatDeviationPrefix,
  formatDuration,
  formatPercentage,
} from '../../../common';
import { Presenter } from '../../../common/ddd/presenter.base';
import { ChallengeInsightProgressDigitalIntensitySummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-digital-intensity.aggregate-root';
import { ChallengeInsightProgressDigitalWorkingHoursSummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-digital-working-hours.aggregate-root';
import { ChallengeInsightProgressFocusV1SummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-focus-v1.aggregate-root';
import { ChallengeInsightProgressSelfReportSummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-self-report.aggregate-root';
import { ChallengeInsightProgressSentimentSummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-sentiment.aggregate-root';
import { ChallengeInsightProgressTimeInAppSummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-time-in-app.aggregate-root';
import { ChallengeInsightProgressTimeInCallsSummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-time-in-calls.aggregate-root';
import { ChallengeInsightProgressTimeInCategorySummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-time-in-category.aggregate-root';
import { ChallengeInsightProgressTimeInMeetingsSummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-time-in-meetings.aggregate-root'; // Added import for ChallengeInsightProgressTimeInMeetingsSummaryAggregateRoot
import { MetricValueType } from '../../dtos';
import { GetChallengeInsightProgressSummaryResponseDto } from '../../dtos/challenge-insights/get-challenge-insight-progress-summary.response.dto';

export type GetChallengeInsightProgressSummaryPresenterDomainEntities =
  | ChallengeInsightProgressTimeInCategorySummaryAggregateRoot
  | ChallengeInsightProgressTimeInAppSummaryAggregateRoot
  | ChallengeInsightProgressTimeInCallsSummaryAggregateRoot
  | ChallengeInsightProgressFocusV1SummaryAggregateRoot
  | ChallengeInsightProgressSentimentSummaryAggregateRoot
  | ChallengeInsightProgressTimeInMeetingsSummaryAggregateRoot
  | ChallengeInsightProgressDigitalIntensitySummaryAggregateRoot
  | ChallengeInsightProgressSelfReportSummaryAggregateRoot
  | ChallengeInsightProgressDigitalWorkingHoursSummaryAggregateRoot;

export class GetChallengeInsightProgressSummaryPresenter
  implements
    Presenter<
      GetChallengeInsightProgressSummaryPresenterDomainEntities,
      GetChallengeInsightProgressSummaryResponseDto
    >
{
  constructor() {}
  toResponse(
    entity: GetChallengeInsightProgressSummaryPresenterDomainEntities
  ): GetChallengeInsightProgressSummaryResponseDto {
    const value = Number(entity.value.toFixed(1));
    const average = Number(entity.average.toFixed(1));
    const formattedAverage =
      entity.type === MetricValueType.Duration
        ? formatDuration(entity.average)
        : String(Math.round(entity.average));
    const formattedValue =
      entity.type === MetricValueType.Duration
        ? formatDuration(entity.value)
        : String(Math.round(entity.value));

    const endDateValue = Number(entity.todayAverage.toFixed(1));

    const formattedEndDateValue =
      entity.type === MetricValueType.Duration
        ? formatDuration(entity.todayAverage)
        : entity.type === MetricValueType.Boolean
          ? formatPercentage(Math.round(entity.todayAveragePercentage))
          : String(Math.round(entity.todayAverage));

    const formattedDeviation =
      entity.type === MetricValueType.Duration
        ? formatDuration(entity.deviation)
        : Math.round(entity.deviation);

    return {
      value,
      average,
      endDateValue,
      formattedEndDateValue,
      formattedValue,
      formattedAverage,
      formattedDeviation: `${formatDeviationPrefix(
        entity.deviation
      )}${formattedDeviation}`, // deviation against challenge target (NOT FROM PERIOD)
      userCount: entity.count,
      formattedSuccessPercentage: formatPercentage(
        Math.round(entity.successPercentage)
      ),
      projectedSuccessForToday: entity.projectedSuccess,
    };
  }
}
